import Notification from './notification.vue'

export default (Vue) => {
  Vue.component(Notification.name, Notification)
}



// WEBPACK FOOTER //
// ./src/components/notification/index.js